// src/components/DataLoaded.js
import React, { useState, useEffect } from "react";
import { Loader, Progress } from "@mantine/core";
import { Flex, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

const DataLoader = ({ 
	msg, 
	isLoad, 
	subMessage = null,
	stage = null,
	progress = null,
	showElapsedTime = true,
	isLogin = false,
	isXL = false,
	isPublicRoute = false
}) => {
	const { t } = useTranslation();
	const [elapsedTime, setElapsedTime] = useState(0);

	// 경과 시간 추적
	useEffect(() => {
		if (!isLoad || !showElapsedTime) return;

		const startTime = Date.now();
		const timer = setInterval(() => {
			setElapsedTime(Date.now() - startTime);
		}, 1000);

		return () => {
			clearInterval(timer);
			setElapsedTime(0);
		};
	}, [isLoad, showElapsedTime]);

	if (!isLoad) return null;

	// 경과 시간 포맷팅
	const formatElapsedTime = (ms) => {
		const seconds = Math.floor(ms / 1000);
		if (seconds < 60) return `${seconds}${t("loading.seconds")}`;
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes}${t("loading.minutes")} ${remainingSeconds}${t("loading.seconds")}`;
	};

	// Main 영역의 left offset 계산
	const getMainLeftOffset = () => {
		if (!isLogin) return 0; // 로그인하지 않은 경우
		if (isPublicRoute) return 0; // 공개 라우트인 경우
		if (isXL) return 0; // XL 브레이크포인트 이상인 경우
		return 151; // XL 미만이고 로그인한 경우: 302px / 2 = 151px
	};

	return (
		<Flex
			justify="center"
			align="center"
			direction="column"
			c="gray.1"
			bg="gray.8"
			p={24}
			gap={12}
					style={{
			position: "fixed",
			bottom: "24px",
			left: `calc(50% + ${getMainLeftOffset()}px)`,
			transform: "translateX(-50%)",
			borderRadius: "8px",
			zIndex: 1000,
			textAlign: "center",
			minWidth: "320px",
			maxWidth: "420px",
		}}
		>
			<Loader type="dots" color="gray.1" size="lg" />
			<Text fz="xl" fw={600}>{msg}</Text>
			
			{/* 진행률 바 */}
			{progress && progress.total > 0 && (
				<Progress 
					value={(progress.completed / progress.total) * 100} 
					size="md" 
					radius="sm"
					color="blue"
					style={{ width: "100%" }}
				/>
			)}
			
			{/* 서브 메시지 (날짜 범위, 진행 상황 등) */}
			{subMessage && (
				<Text fz="md" c="gray.2" style={{ textAlign: "center" }}>
					{subMessage}
				</Text>
			)}
			
			{/* 경과 시간 표시 */}
			{showElapsedTime && elapsedTime > 3000 && (
				<Text fz="md" c="gray.2">
					{t("loading.elapsed_time")} {formatElapsedTime(elapsedTime)}
				</Text>
			)}
		</Flex>
	);
};

export default DataLoader;
